import { render, staticRenderFns } from "./users_table.vue?vue&type=template&id=bb43da36&"
import script from "./users_table.vue?vue&type=script&lang=js&"
export * from "./users_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports